<template>
  <div class="container flex flex-between">
    <img
        class="banner"
        src="https://imagepub.chinau8.cn/tianhua_jinhua/tianhua-website/company.png"
        alt=""
    />
    <div class="info">
      <div class="desc-title">公司简介</div>
      <div class="h1">一、公司概况</div>
      <div class="info-text-box">
        金华市天华网络科技有限公司成立于2009年，是一家专注于行业信息化建设、大数据管理及智慧无人机应用开发、无人机应用运维、无人机培训的高新技术企业。
      </div>
      <div class="info-text-box">
        公司自成立以来，先后被国家、省、市相关部门认定为“浙江省电子商务模式创新10强企业”、“浙江省国际服务外包重点企业”、“浙江省科技型中小型企业”、“浙江省电子商务服务示范企业”、“浙江省优秀成长企业”、“双软企业”、“浙江省国际服务外包人才培训机构”、“浙江省成长型服务外包企业”、“浙江省国际服务外包人才培训机构前十强”、“金华市诚信经营企业示范单位”、“金华市网络经济人才培训机构”、“金东区科技成果转化先进单位”、“金东区创新新型企业”、“金东区服务业重点企业”等，获得近二十项荣誉，软件著作权三十余个。
      </div>
      <div class="info-text-box">
        随着低空经济的快速发展，天华科技积极拓展无人机应用场景业务及培训服务，结合自身在大数据、云计算、物联网等领域的技术积累，构建“无人机+行业应用+数据智能”的全新业务生态。
      </div>
      <div class="h1">二、核心业务板块</div>
      <div class="h2">1. 行业信息化与大数据服务</div>
      <div class="info-text-box">
        政务大数据平台：为政府提供智慧城市、应急管理、社会治理等数据治理与分析服务。
企业数字化管理云平台：覆盖ERP、CRM、供应链管理等企业级SaaS应用。
      </div>
      <div class="h2">2. 无人机行业应用</div>
      <div class="info-text-box">
        无人机智慧巡检：城市综合治理智慧巡检、城市规划三维建模
无人机应急与安防：灾害监测、应急救援指挥系统
无人机物流与农业：低空物流配送（与本地电商、物流企业合作）；精准农业植保、农田监测
      </div>
      <div class="h2">3. 无人机培训（新增业务）</div>
      <div class="info-text-box">
        CAAC无人机驾驶员培训
提供多旋翼、固定翼等机型的执照考试培训；涵盖视距内（VLOS）、超视距（BVLOS）等执照类别
      </div>
      <div class="h1">三、技术优势</div>
      <div class="info-text-box">
        自主研发能力：拥有30+项软件著作权，具备大数据分析、AI视觉识别等核心技术。
无人机+数据融合：通过无人机采集数据，结合云端分析，提供智能决策支持。
本地化服务网络：在金华及周边地区设立技术服务中心，提供快速响应支持。
      </div>
      <div class="h1">四、未来发展方向</div>
      <div class="info-text-box">
        1.	打造“无人机+行业SaaS”平台，实现数据采集、分析、管理一体化。
2.	建立金华地区无人机培训示范基地，推动低空经济人才培养。
3.	拓展政企合作，参与智慧城市、低空物流等试点项目。
天华科技将持续以技术创新为核心，助力行业数字化转型，推动无人机技术在智慧城市、应急管理、农业、物流等领域的深度应用，为社会创造更大价值！
      </div>
      <div class="info-text-box"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "aboutTianHua",
  data() {
    return {
      list: ["基础设施", "平台软件", "数据信息", "应用软件"],
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  //min-height: 510px;
  margin: 0 auto;

  .banner {
    width: 635px;
    height: 420px;
    margin-right: 30px;
    // marbin-bottom: 30px;
  }

  .h1 {
    color: rgba(5, 6, 10, 1);
    font-size: 15px;
    font-weight: bold;
    text-align: left;
    margin-bottom: 0px;
  }
  .h2 {
    color: rgba(5, 6, 10, 1);
    font-size: 9px;
    font-weight: bold;
    text-align: left;
    margin-bottom: 0px;
  }

  .info {
    display: flex;
    flex-direction: column;
    text-align: left;

    .info-text-box {
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      // line-height: 24px;
      margin-bottom: 0px;
      text-indent: 2em;
    }

    .desc-title {
      font-size: 32px;
      font-weight: bold;
      color: #333333;
      line-height: 38px;
      margin-bottom: 15px;
    }

    .business {
      width: 175px;
      height: 50px;
      flex-shrink: 0;
      margin-right: 20px;
      margin-bottom: 22px;
      line-height: 50px;
      font-size: 20px;
      border-radius: 10px;
      background-color: rgba(255, 255, 255, 1);
      text-align: center;
      box-shadow: 3px 3px 0px 0px rgba(52, 111, 255, 0.2);
      border: 1px solid rgba(52, 111, 255, 0.1);
    }
  }
}
</style>
